import React from "react";
import { Link } from "react-router-dom";
// import imageLookbackReview from "assets/boost/reviews-lookback.png";
import { toEmoji } from "utils/tomoEmoji";
import { boostLookbackSelectionUrl, boostTiers } from "../consts";

const BoostLookback = ({ currentTier, currentTerm }) => {
  const shouldHide = currentTier === boostTiers.VIP && currentTerm === "yearly";

  return (
    <div className="mt-10 border-2 border-white rounded-xl w-full border-glow-white-sharp p-5 bg-black bg-opacity-50">
      <div className="text-2xl font-semibold mb-2 text-boost-lighter-purple text-left">
        Boost Further<span className="text-white">.</span>
      </div>
      <div className="flex flex-row justify-evenly items-start flex-wrap md:flex-nowrap">
        <div className="flex flex-col items-start text-md mb-4">
          <ul className="list-disc text-left ml-4">
            <li>
              <div className="flex">
                <span className="mt-1 mr-1">{toEmoji("💰")}</span> Credit Limit
                Increase - $30,000
              </div>
            </li>
            <li>
              <div className="flex whitespace-nowrap md:whitespace-pre-wrap">
                <span className="mt-1 mr-1">{toEmoji("⚡")}</span>Expedited
                Credit Reporting & more...
              </div>
            </li>
          </ul>
        </div>
        {!shouldHide && (
          <Link
            className="whitespace-nowrap bg-white text-black font-semibold hover:font-semibold rounded-xl px-2 py-2 leading-none"
            to={{ pathname: boostLookbackSelectionUrl }}
            style={{
              boxShadow: "0px 0px 50px #9B8DB2, 0px 0px 25px #4B2BA3",
              animation: "custom-bounce 5s infinite linear",
            }}
          >
            + Upgrade
          </Link>
        )}
      </div>
    </div>
  );
};

export default BoostLookback;